import React from 'react';
import PropTypes from 'prop-types';
import ModalToBody from '../../../base/ModalToBody';
import { Trans } from 'react-i18next';
import moment from 'moment';

class CrewMembersOverviewButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false
    };

    this._closeModal = this._closeModal.bind(this);
    this._openModal = this._openModal.bind(this);
  }

  static propTypes = {
    registrationProfiles: PropTypes.array
  };

  _closeModal() {
    this.setState({ showModal: false });
    document.body.classList.remove('modal-open');
  }

  _openModal() {
    this.setState({ showModal: true });
    document.body.classList.add('modal-open');
  }

  render() {
    const { showModal } = this.state;
    const { registrationProfiles } = this.props;

    let minDay, maxDay;
    for (let i = 0; i < registrationProfiles.length; i++) {
      for (let j = 0; j < registrationProfiles[i].amountPerDay.length; j++) {
        const date = moment(registrationProfiles[i].amountPerDay[j].day);
        if (!minDay || minDay.diff(date) > 0) {
          minDay = date;
        }

        if (!maxDay || maxDay.diff(date) < 0) {
          maxDay = date;
        }
      }
    }

    const days = [];
    if (minDay) {
      while (minDay.diff(maxDay) < 0) {
        days.push(moment(minDay));
        minDay.add(1, 'day');
      }

      if (minDay.diff(maxDay) === 0) {
        days.push(moment(minDay));
      }
    }

    return (
      <div>
        <button
          type="button"
          className="m-portlet__nav-link btn btn-accent m-btn m-btn--icon"
          onClick={this._openModal}
        >
          <span>
            <i className="la la-eye" />
            <span>
              <Trans>RegistrationCrewMembersShowOverviewButton</Trans>
            </span>
          </span>
        </button>

        <ModalToBody>
          <div
            className="modal fade show"
            id="m_modal_4"
            tabIndex="-1"
            role="dialog"
            aria-labelledby="exampleModalLabel"
            style={{
              display: showModal ? 'block' : 'none',
              zIndex: '1039'
            }}
          >
            <div className="modal-dialog modal-lg" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title" id="exampleModalLabel">
                    <Trans>RegistrationCrewMembersOverviewTitle</Trans>
                  </h5>
                  <button
                    type="button"
                    className="close"
                    data-dismiss="modal"
                    aria-label="Close"
                    onClick={this._closeModal}
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  {registrationProfiles && (
                    <table className="table table-striped m-table">
                      <thead>
                        <tr>
                          <th>
                            <Trans>Day</Trans>
                          </th>
                          {registrationProfiles.map(rProfile => (
                            <th key={rProfile.id}>{rProfile.profile.name}</th>
                          ))}
                        </tr>
                      </thead>
                      <tbody>
                        {days.map(day => (
                          <tr key={day}>
                            <th scope="row">{day.format('DD/MM/YYYY')}</th>
                            {registrationProfiles.map(rProfile => {
                              const dayAmounts = rProfile.amountPerDay.filter(
                                aday => aday.day === day.format('YYYY-MM-DD')
                              );
                              const currentLimit =
                                dayAmounts.length > 0
                                  ? dayAmounts[0]
                                  : { used: 0, max: 0 };
                              const used = currentLimit ? currentLimit.used : 0;
                              const max = currentLimit
                                ? currentLimit.amount
                                : 0;

                              return (
                                <td key={day + rProfile.id}>
                                  {used + ' '}
                                  <span className="tableMax">of max {max}</span>
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  )}
                </div>
              </div>
            </div>
          </div>

          <div
            className={'modal-backdrop fade ' + (showModal ? ' show' : '')}
            style={{
              display: showModal ? 'block' : 'none',
              zIndex: '1038'
            }}
            onClick={this._closeModal}
          />
        </ModalToBody>
      </div>
    );
  }
}

export default CrewMembersOverviewButton;
